import React from 'react'
import Tableofnames from './Tableofnames'
import Title from '../../atoms/Title';
import { useTranslation } from 'react-i18next';

const names = [
  { id: 1, name: "أحمد عرابي" },
  { id: 2, name: "ابراهيم اصلان" },
  { id: 3, name: "ابراهيم حمودة" },
  { id: 4, name: "ابراهيم الرفاعي" },
  { id: 5, name: "ابراهيم رجب" },
  { id: 6, name: "ابراهيم الشامي" },
  { id: 7, name: "ابراهيم بدران" },
  { id: 8, name: "ابراهيم خان" },
  { id: 9, name: "ابراهيم خان" },
  { id: 10, name: "ابراهيم خان" },
  { id: 11, name: "ابراهيم حمودة" },
  { id: 12, name: "ابراهيم الرفاعي" },
  { id: 13, name: "ابراهيم رجب" },
  { id: 14, name: "ابراهيم الشامي" },
  { id: 15, name: "ابراهيم خان" },
  { id: 16, name: "ابراهيم خان" },
  { id: 17, name: "ابراهيم خان" },
  { id: 18, name: "ابراهيم حمودة" },
  { id: 19, name: "ابراهيم الرفاعي" },
  { id: 20, name: "ابراهيم رجب" },
  { id: 21, name: "ابراهيم الشامي" },
  { id: 22, name: "ابراهيم الرفاعي" },
  { id: 23, name: "ابراهيم خان" }
]
;
const title1="حرف  الألف"
const title2="حرف  الباء"
const title3 = "حرف  التاء"
const title=[title1,title2,title3]
export default function Content({title, contentData}) {
  // console.log('Pagetemmmmmmmmmmmplate', contentData)
  const { t, i18n } = useTranslation();
  const isArabic = (i18n.language?.split("-")[0] || "ar") === "ar";
  const groupTitle = (item) =>
    (isArabic ? item?.letter : item?.letterE || item?.letter) ||
    (isArabic ? item?.fieldSpecialityTitle : item?.fieldSpecialityEngTitle) ||
    t("common.noData");

  return (
    <div className='bg-rd-400 my-[40px]'>
        {contentData?.length === 0 || contentData === undefined ? <Title primary2>{t("common.noData")}</Title>:
            contentData?.map((item, index) => {
              {/* console.log(index, item) */}
          return (
            <div key={index} className='mt-[40px]'>
              <Tableofnames title={groupTitle(item)} data={item?.characters || item?.characterDtos} />
            </div>
          );
        })

        }
        {/* <div className=' mt-[40px]'>
          <Tableofnames title={title[0]} data={names}></Tableofnames>
        </div>
        <div className=' mt-[40px]'>
          <Tableofnames title={title[1]} data={names}></Tableofnames>
        </div>
        <div className=' mt-[40px]'>
          <Tableofnames title={title[2]} data={names}></Tableofnames>
        </div> */}
    </div>
  )
}
